import React, { useState } from 'react';
// import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { Search, MapPin, AlertCircle } from 'lucide-react';
import { HOME_CONSTANT } from '../constants/Home';
import { COMMON_CONSTANTS } from '../constants/Common';
import { AXIOS_HELPERS } from '../helpers/Axios';
import '../css/HomeSearchLand.css';


const { config: { base_url } } = COMMON_CONSTANTS;
const { country, states } = HOME_CONSTANT;
const { MakeAxiosCall } = AXIOS_HELPERS


const LandSearch = ({ setAllLandList, filteredListing }) => {
    // const [landType, setLandType] = useState('');
    const [state, setState] = useState('');
    const [district, setDistrict] = useState('');
    const [allLands, setAllLands] = useState([]);
    const [totalListings, setTotalListings] = useState(0);
    const [showPopup, setShowPopup] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    const handleSearch = async (e, reset = false) => {
        e.preventDefault()
        if (!state) return;

        // console.log('reset======>', reset)

        setIsLoading(true);
        try {
            const options = {
                url: `${base_url}/getlands`,
                params: { page: 1, length: 12, ...(!reset && { state, district }) },
                method: 'GET',
                maxBodyLength: Infinity
            }
            console.log('option', options)
            const response = await MakeAxiosCall(options)

            if (response.data) {
                setAllLands(response?.data?.data?.data);
                setTotalListings(response?.data?.data?.totalListings || 0);
                navigate(`/${state}/${district}`, {
                    state: { allLands, totalListings, state, district }
                });
                setAllLandList(response?.data?.data?.data)
                filteredListing(response?.data?.data?.totalListings || 0)

            }
        } catch (error) {
            console.error('Error fetching lands:', error);
            if (error?.response?.status === 401) {
                setShowPopup(true);
            }
        } finally {
            setIsLoading(false);
        }
    };

    const handlePopupClose = () => {
        setShowPopup(false);
        navigate('/login');
    };

    return (
        <div className="search-wrapper">
            <div className="search-container">
                <h2>Search Your Dream Land</h2>
                {/* <h2>अब ज़मीन की तलाश नहीं, बस एक क्लिक!</h2> */}
                <h2>अब ज़मीन खरीदें या बेचें डिजिटल तरीके से</h2>
                {/* <h2>100% पारदर्शिता, 100% भरोसा</h2> */}
                {/* <h2>ज़मीन के सौदे अब आसान</h2> */}
                {/* <h2>अब खेतों की खरीद-बिक्री मोबाइल से</h2> */}


                <div className="search-bar-container">
                    {/* <div className="search-group">
                        <Home className="search-icon" />
                        <select
                            className="search-dropdown"
                            onChange={(e) => setLandType(e.target.value)}
                            value={landType}
                        >
                            <option value="" disabled>Select Land Type</option>
                            <option value="agriculture">Agriculture</option>
                            <option value="residential">Residential</option>
                            <option value="commercial">Commercial</option>
                        </select>
                    </div> */}

                    <div className="search-group">
                        <MapPin className="search-icon" />
                        <select
                            className="search-dropdown"
                            onChange={(e) => setState(e.target.value)}
                            value={state}
                            required
                        >
                            <option value="" disabled>Select State</option>
                            {country?.india?.map((eachState, index) => (
                                <option key={index} value={eachState}>{eachState}</option>
                            ))}
                        </select>
                    </div>

                    <div className="search-group">
                        <MapPin className="search-icon" />
                        <select
                            className="search-dropdown"
                            onChange={(e) => setDistrict(e.target.value)}
                            value={district}
                        >
                            <option value="" disabled>Select District</option>
                            {state && states[state]?.map((eachDistrict, index) => (
                                <option key={index} value={eachDistrict}>{eachDistrict}</option>
                            ))}
                        </select>
                    </div>

                    <button
                        className={`search-button ${isLoading ? 'loading' : ''}`}
                        disabled={!state || isLoading}
                        onClick={handleSearch}
                    >
                        {isLoading ? (
                            <span className="loader"></span>
                        ) : (
                            <>
                                <Search className="button-icon" />
                                Search
                            </>
                        )}
                    </button>
                    <button className='reset-button' style={{}}
                        onClick={(e) => handleSearch(e, true)}>Reset</button>
                </div>
            </div>

            {showPopup && (
                <div className="popup-overlay">
                    <div className="popup">
                        <AlertCircle className="popup-icon" />
                        <p>Session has expired. Please login again.</p>
                        <button onClick={handlePopupClose}>Login</button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default LandSearch;